<template>
  <div class="task-box" v-if="body_show">
    <div class="task-title">
      {{ title }}
    </div>
    <!-- 姓名 -->
    <van-cell-group class="grouping pj2-task">
      <van-field placeholder="请填写对标人物的姓名" v-model="figure_name" label="用户名" />
    </van-cell-group>
    <!-- 对标人物照片 -->
    <div class="pj-task-group">
      <h3>照片</h3>
      <div class="upload-img">
        <a href="javascript:;" v-if="uploadImgBool" @click="uploadImgHandle">
          <img :src="targetheadimg" />
        </a>
        <a href="javascript:;" v-else >
          <van-uploader  name="uploader" :after-read="onRead">
            <img :src="targetheadimg" />
          </van-uploader>
        </a>
        <p>(请填写对标人物的照片)</p>
      </div>
    </div>
    <!-- 从事行业 -->
    <van-cell-group class="grouping pj-task-group">
      <van-field placeholder="请填写对标人物的从事行业" v-model="figure_trade" label="从事行业" @blur="check_length('figure_trade', 8)" />
      <span class="number-words">{{figure_trade.length}}/8</span>
    </van-cell-group>
    <!-- 最高头衔 -->
    <van-cell-group class="grouping pj-task-group">
      <van-field placeholder="请填写对标人物的最高头衔" v-model="figure_title" label="最高头衔" @blur="check_length('figure_title', 8)" />
      <span class="number-words">{{figure_title.length}}/8</span>
    </van-cell-group>
    <!-- 家庭出身 -->
    <div class="pj2-task-family">
      <h2>对标人物的家庭出身（1条）</h2>
      <van-cell-group class="grouping">
        <van-field placeholder="选择对标人物的出生年份"  v-model="birthdate" label="时间" @click="pickerType(1)" readonly />
        <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
      </van-cell-group>
      <!-- 出身 -->
      <van-cell-group class="grouping pj-task-group">
        <van-field placeholder="对标人物的家庭出身，如：工薪阶层" v-model="figure_origin" label="出身" @blur="check_length('figure_origin', 14)" />
        <span class="number-words">{{figure_origin.length}}/14</span>
      </van-cell-group>
      <!-- 家庭背景 -->
      <van-cell-group class="grouping rich_text task-textarea-title">
        <van-field placeholder="请简要描述其家庭成长环境" type="textarea" v-model="figure_familybg" label="家庭背景" @blur="check_length('figure_familybg', 39)" />
        <span class="number-words">{{figure_familybg.length}}/39</span>
      </van-cell-group>
    </div>
    <!-- 教育经历 -->
    <div class="pj2-task-family">
      <h2>对标人物的教育经历（填写最高学历）</h2>
      <van-cell-group class="grouping">
        <van-field placeholder="选择对标人物最高学历的毕业年份" v-model="education_time" label="时间" @click="pickerType(2)" readonly />
        <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
      </van-cell-group>
      <!-- 学校 -->
      <van-cell-group class="grouping pj-task-group">
        <van-field placeholder="对标人物最高学历的就读学校" v-model="education_school" label="学校" @blur="check_length('education_school', 14)" />
        <span class="number-words">{{education_school.length}}/14</span>
      </van-cell-group>
      <!-- 家庭背景 -->
      <van-cell-group class="grouping rich_text task-textarea-title">
        <van-field placeholder="请简要列举对标人物在学校的重要经历" type="textarea" v-model="education_stage" label="学习经历" @blur="check_length('education_stage', 39)" />
        <span class="number-words">{{education_stage.length}}/39</span>
      </van-cell-group>
    </div>
    <!-- 职业经历 -->
    <div class="pj2-task-family">
      <h2>对标人物的职业经历（5条）</h2>
      <div class="task-career" v-for="(item,index) in career_length" :key="index">
        <van-cell-group class="grouping">
          <van-field placeholder="选择这段职业经历的开始年份" v-model="career_time[index]" label="时间" @click="pickerType(3,index,career_time[index])" readonly />
          <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
        </van-cell-group>
        <!-- 职位 -->
        <van-cell-group class="grouping pj-task-group">
          <van-field placeholder="对标人物在这家公司的职位" @input="space_constraints(index,'career_title')" v-model="career_title[index]" label="职位" @blur="check_length('career_title', 14, index)" />
          <span class="number-words">{{career_title[index].length}}/14</span>
        </van-cell-group>
        <!-- 重要经历 -->
        <van-cell-group class="grouping rich_text task-textarea-title">
          <van-field placeholder="请简要描述对标人物在这家公司的重要经历" type="textarea" @input="space_constraints(index,'career_event')" v-model="career_event[index]" label="关键事件" @blur="check_length('career_event', 39, index)" />
          <span class="number-words">{{career_event[index].length}}/39</span>
        </van-cell-group>
      </div>
    </div>
    <!-- 职业经历编辑 -->
    <div :class="['career-editor',career_length<2 ? 'career-one' : '']">
      <div class="career-editor-child" v-show="career_length<5" @click="addCarrer">
        <img src="@a/add.png" />
        <h2>添加职业经历</h2>
      </div>
      <div v-show="career_length>1" class="career-editor-child" @click="show">
        <img src="@a/delete.png" />
        <h2>删除职业经历</h2>
      </div>
    </div>
    <!-- 提交 -->
    <div class="submitBtn">
      <van-button v-if="validationHandle()" @click="submitHandle" class="actice">提交</van-button>
      <van-button v-else>提交</van-button>
    </div>
    <!-- 时间选择框 -->
    <van-popup v-model="picker_show" position="bottom">
      <!-- 家庭出身 -->
      <van-picker v-show="picker_type==1" :default-index="birthdate_index" show-toolbar :columns="years" @cancel="cancel" @confirm="confirm" />
      <!-- 教育经历 -->
      <van-picker v-show="picker_type==2" :default-index="education_time_index" show-toolbar :columns="years" @cancel="cancel" @confirm="confirm" />
      <!-- 职业经历 -->
      <van-picker v-show="picker_type==3" :default-index="career_time_index" show-toolbar :columns="years" @cancel="cancel" @confirm="confirm" />
    </van-popup>
    <!-- 确认提交弹窗 -->
    <van-popup class="pub_alert" v-model="alert_show">
      <div class="confirm_box">
        <h2>确定要删除此条经历吗？</h2>
        <div class="btn_group">
          <a class="cancel on" href="javascript:;" @click="hide">取消</a>
          <a class="confirm" href="javascript:;" @click="deleteCareer">确认</a>
        </div>
      </div>
    </van-popup>
    <!-- 弹出层 -->
    <van-popup :close-on-click-overlay="false" v-model="nextModule">
      <div class="modules">
        <div class="head clearfix">
          <img @click="nextModule = false" class="close" src="@a/close.png" alt="" />
        </div>
        <div class="con-img">
          <img src="@a/pr1.png" alt="图片正在加载中..." />
        </div>
        <div class="con-text">
          任务就像消消乐，完成就好，继续加油！
        </div>
        <router-link class="next-btn" :to="{path: 'project2_task2_new', query: objArg}">去开启下一任务</router-link>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { getStorage, setStorage,isWeixin } from "@/utils/tools"
import { getprototypedata, updateprototypedata, save_user_head,upload_image_file,save_user_head_image } from "@/api/course"
import { shareCon } from "@/utils/wxconfig";
import wx from "weixin-js-sdk"
let imgSrc = require('../../../assets/upload_img.png');
export default {
  data() {
      return {
        body_show: false,
        title: 'T1：对标人物发展年表',
        figure_name: '',
        targetheadimg: '',
        figure_trade: '',
        figure_title: '',
        birthdate: '',
        arrow: false,
        figure_origin: '',
        figure_familybg: '',
        education_time: '',
        education_school: '',
        education_stage: '',
        career_time: [],
        career_title: [],
        career_event: [],
        picker_show: false,
        years: [],
        picker_type: 0,
        career_length: 0,
        alert_show: false,
        nextModule: false,
        serverId: '',
        imgDefault: false,
        carrer_index: 0,
        objArg: {
          cid: "",
          pid: "",
          id: "",
          name: ""
        },
        birthdate_index:0,
        education_time_index:0,
        career_time_index:0,
        data:{},
        // 上传图片类型
        uploadImgBool:true,
        image_url:''
      }
    },
    methods: {
      // 上传图片判断
      onRead(files,detail){
        // FormData 对象
        let form = new FormData();
        // 文件对象
        form.append("image", files.file);
  
        // 上传图片接口
        upload_image_file(form).then((res) => {
          if (res.code ==10002) {
            this.$toast(res.msg);
            return
          }
          save_user_head_image({
            cid: this.$route.query.cid,
            head:res.image_url,
            type: 'targetreport'
          }).then(data => {
              this.targetheadimg = res.image_url;
              this.imgDefault = true;
            });
        });
      },
      // 初始化方法
      pullData() {
        //调用加载中
        this.$emit('loadingHandle',true,"拼命加载中...");
        getprototypedata({
            cid: this.$route.query.cid,
            type: "taskone"
          })
          .then(data_ => {
            if(!isWeixin()){
              this.uploadImgBool = false;
            }
            this.body_show = true;
             // 给时间选择框赋值
            this.handleForTime();
            let t = data_.data.timeline;
            let d = data_.data;
            this.data = data_.data;
            let path = this.$route.path;
            this.figure_name = t.figure_name ? t.figure_name : getStorage(path, 'figure_name') || '';
            this.imgDefault = d.targetheadimg ? true : false;
            this.targetheadimg = d.targetheadimg ? d.targetheadimg : imgSrc || '';
            this.figure_trade = t.figure_trade ? t.figure_trade : getStorage(path, 'figure_trade') || '';
            this.figure_title = t.figure_title ? t.figure_title : getStorage(path, 'figure_title') || '';
            this.birthdate = t.birthdate ? t.birthdate : getStorage(path, 'birthdate') || '';
            this.figure_origin = t.figure_origin ? t.figure_origin : getStorage(path, 'figure_origin') || '';
            this.figure_familybg = t.figure_familybg ? t.figure_familybg : getStorage(path, 'figure_familybg') || '';
            this.education_time = t.education_time ? t.education_time : getStorage(path, 'education_time') || '';
            this.education_school = t.education_school ? t.education_school : getStorage(path, 'education_school') || '';
            this.education_stage = t.education_stage ? t.education_stage : getStorage(path, 'education_stage') || '';
            // 给职业经历循环数赋值
            this.career_length = t.career ? t.career.length : (getStorage(path, 'career_time').length) || '';
            for (let i = 0; i < t.career.length; i++) {
              this.career_time.push(
                t.career[i].time ? t.career[i].time : getStorage(path, 'career_time')[i] || ''
              );
              this.career_title.push(
                t.career[i].title ? t.career[i].title : getStorage(path, 'career_title')[i] || ''
              );
              this.career_event.push(
                t.career[i].event ? t.career[i].event : getStorage(path, 'career_event')[i] || ''
              );
            }
            // 给日期弹出框默认选择当前值
            for(let k = 0;k<this.years.length;k++){
                if(this.years[k] ==t.birthdate){
                  this.birthdate_index = k;
                  break;
                }
            }
            // 给日期弹出框默认选择当前值
            for(let k = 0;k<this.years.length;k++){
                if(this.years[k] ==t.education_time){
                  this.education_time_index = k;
                  break;
                }
            }
            //关闭加载中
            this.$emit('loadingHandle',false);
          });
      },
      // 验证
      validationHandle() {

        for (let i = 0; i < this.career_length; i++) {
          if (this.$Validator.isEmpty(this.career_time[i])) {
            return false;
          }
          if (this.$Validator.isEmpty(this.career_title[i])) {
            return false;
          }
          if (this.$Validator.isEmpty(this.career_event[i])) {
            return false;
          }
        }

        if (!this.imgDefault) {
          return false;
        }

        let str_fields = [
          'figure_name',
          'figure_trade',
          'figure_title',
          'birthdate',
          'figure_origin',
          'figure_familybg',
          'education_time',
          'education_school',
          'education_stage'
        ];
        // 循环判断数组内属性内容是为空
        for (let i = 0; i < str_fields.length; i++) {
          if (this.$Validator.isEmpty(this[str_fields[i]])) {
            return false;
          }
        }
        return true;
      },
      // 判断是哪一个属性的选择框
      pickerType(type, index,val) {
        // 1 家庭背景出生时间、2 教育经历、3 职业经历
        this.picker_type = type;
        this.carrer_index = index;
        this.picker_show = true;


        // 给日期弹出框默认选择当前值
        if(type==3){
          for(let k = 0;k<this.years.length;k++){
              if(this.years[k] ==val){
                this.career_time_index = k;
                break;
              }
          }
        }
      },
      cancel(data) {
        this.picker_show = false;

      },
      // 弹出选择框  1 家庭背景出生时间、2 教育经历、3 职业经历
      confirm(data) {
        if (this.picker_type == 1) {
          this.birthdate = data.toString();
        } else if (this.picker_type == 2) {
          this.education_time = data.toString();
        } else if (this.picker_type == 3) {
          this.career_time[this.carrer_index] = data.toString();
          setStorage(this.$route.path, 'career_time', this.career_time);
        }
        this.picker_show = false;
      },
      // 循环得到时间数据（从1900-至今年）
      handleForTime() {
        var years = [];
        var myDate = new Date(); //获取系统当前时间
        for (var i = 1900; i <= myDate.getFullYear(); i++) {
          years.push(i);
        }
        this.years = years
      },
      hide() {
        this.alert_show = false;
      },
      show() {
        this.alert_show = true;
      },
      // 添加职业经历
      addCarrer() {
        if (this.career_length < 5) {

          this.career_length = this.career_length + 1;
          this.career_time.push('');
          this.career_title.push('');
          this.career_event.push('');

        }
        // }
      },
      // 删除职业经历career_length
      deleteCareer() {
        this.career_time.splice(this.career_length - 1, 1);
        this.career_title.splice(this.career_length - 1, 1);
        this.career_event.splice(this.career_length - 1, 1);

        this.career_length -= 1;
        this.hide();
      },
      // 判断字符长度
      space_constraints(index, name) {
        if (name == 'career_title') {
          if (this.career_title[index].length > 14) {
            // this.$set(this.career_title, index, this.career_title[index].slice(0, 14));
            // this.$toast('最多只能输入' + 14 + '个字。/(ㄒoㄒ)/~~！');
          } else {
            setStorage(this.$route.path, 'career_title', this.career_title);
          }
        }
        if (name == 'career_event') {
          if (this.career_event[index].length > 39) {
            // this.$set(this.career_event, index, this.career_event[index].slice(0, 39));
            // this.$toast('最多只能输入' + 39 + '个字。/(ㄒoㄒ)/~~！');
          } else {
            setStorage(this.$route.path, 'career_event', this.career_event);
          }
        }
      },
      check_length(field, max_len, idx) {
        let val = this[field];
        if(idx !== undefined) {
          val = this[field][idx];
        }
        if(val.length > max_len) {
          if(idx !== undefined) {
            this.$set(this[field], idx, val.slice(0, max_len));
          } else {
            this[field] = val.slice(0, max_len);
          }
          this.$toast('最多只能输入' + max_len + '个字。/(ㄒoㄒ)/~~！');
        }
      },
      // 提交数据
      submitHandle() {
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        updateprototypedata({
            cid: this.$route.query.cid,
            type: "taskone",
            cpid: this.$route.query.pid,
            cptid: this.$route.query.id,
            iscreate: 1,
            figure_name: this.figure_name,
            figure_trade: this.figure_trade,
            figure_title: this.figure_title,
            birthdate: this.birthdate,
            figure_origin: this.figure_origin,
            figure_familybg: this.figure_familybg,
            education_time: this.education_time,
            education_school: this.education_school,
            education_stage: this.education_stage,
            worktime: this.career_time,
            worktitle: this.career_title,
            workevent: this.career_event
          })
          .then(data => {
            this.$toast.clear();
            this.nextModule = true;
            this.objArg.cid = this.$route.query.cid;
            this.objArg.id = data.cptid;
            this.objArg.pid = this.$route.query.pid;
            this.objArg.name = encodeURIComponent(data.name);
          });

      },
      // 上传图片
      uploadImgHandle() {
        wx.chooseImage({
          count: 1,
          sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
          sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
          success: (res) => {
            // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
            wx.uploadImage({
              localId: res.localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success: (res2) => {
                this.serverId = res2.serverId;
                this.imgSave();
              }
            });
          }
        });

      },
      imgSave() {

        save_user_head({
          cid: this.$route.query.cid,
          server_id:this.serverId,
          type: 'targetreport'
        }).then(data => {
            this.targetheadimg = data.headimgurl;
            this.imgDefault = true;
          });
      },
      setTitle(){
        let title = this.$route.query.name;
        document.title = decodeURI(title);
      }
    },
    created() {
      this.pullData();
      this.setTitle();
      shareCon("course",this);
    },
    watch: {
      figure_trade(newVal, oldVal) {
        if (newVal.length > 8) {
          // this.figure_trade = newVal.slice(0, 8);
          // this.$toast('最多只能输入' + 8 + '个字。/(ㄒoㄒ)/~~！');
        } else {
          setStorage(this.$route.path, 'figure_trade', newVal);
        }
      },
      figure_title(newVal, oldVal) {
        if (newVal.length > 8) {
          // this.figure_title = newVal.slice(0, 8);
          // this.$toast('最多只能输入' + 8 + '个字。/(ㄒoㄒ)/~~！');
        } else {
          setStorage(this.$route.path, 'figure_title', newVal);
        }
      },

      figure_origin(newVal, oldVal) {
        if (newVal.length > 14) {
          // this.figure_origin = newVal.slice(0, 14);
          // this.$toast('最多只能输入' + 14 + '个字。/(ㄒoㄒ)/~~！');
        } else {
          setStorage(this.$route.path, 'figure_origin', newVal);
        }
      },
      figure_familybg(newVal, oldVal) {
        if (newVal.length > 39) {
          // this.figure_familybg = newVal.slice(0, 39);
          // this.$toast('最多只能输入' + 39 + '个字。/(ㄒoㄒ)/~~！');
        } else {
          setStorage(this.$route.path, 'figure_familybg', newVal);
        }
      },
      education_school(newVal, oldVal) {
        if (newVal.length > 14) {
          // this.education_school = newVal.slice(0, 14);
          // this.$toast('最多只能输入' + 14 + '个字。/(ㄒoㄒ)/~~！');
        } else {
          setStorage(this.$route.path, 'education_school', newVal);
        }
      },
      education_stage(newVal, oldVal) {
        if (newVal.length > 39) {
          // this.education_stage = newVal.slice(0, 39);
          // this.$toast('最多只能输入' + 39 + '个字。/(ㄒoㄒ)/~~！');
        } else {
          setStorage(this.$route.path, 'education_stage', newVal);
        }
      }
    }
}
</script>
<style lang="scss" scoped>
@import "@s/taskStyle.scss";
</style>
